import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {

  constructor(private dialog: MatDialog) { }

  // tslint:disable-next-line: typedef
  openConfirmDialog(messageText, buttonTextok = 'Evet', buttonTextcancel = 'Vazgeç') {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, { disableClose: true ,
      data: {
        message: messageText,
        buttonText: {
          ok: buttonTextok,
          cancel: buttonTextcancel
        }
      }
    });
    return dialogRef;
    // dialogRef.afterClosed().subscribe((confirmed: boolean) => {
    //   if (confirmed) {
    //     this.dialogConfirm = confirmed;
    //   }
    // });
  }
}
